module.exports = __webpack_public_path__ + "img/frame-992.47bae1b3.webp";